module.exports = __webpack_public_path__ + "img/sq6m_feature_02.44997a27.jpg";